// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_container_Y8xSV_wN4WaEy1VPQvOq {
  font-family: Open Sans;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.style-module_container_Y8xSV_wN4WaEy1VPQvOq > * {
  padding-top: 1rem;
}

.style-module_container_Y8xSV_wN4WaEy1VPQvOq:last-child {
  margin-bottom: 5rem;
}

.style-module_moduleContainer_vtxcCrt2vn3GywYAzcZQ {
  width: 50%;
  min-width: 55%;
}
@media screen and (max-width: 800px) {
  .style-module_moduleContainer_vtxcCrt2vn3GywYAzcZQ {
    width: 100%;
  }
}

.style-module_body_RHIu7czkawAfOpTIdmai {
  width: 80%;
}

.style-module_checkbox_pzCewce9MHCmhN7dmU0H:first-child {
  margin-top: 3rem;
}

.style-module_checkboxLabel_jvvrZeG4hGhELiel6sPK {
  display: flex;
  flex-direction: row;
}

.style-module_footer_Br3Sy0LFODuOaozPF179 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
}
.style-module_footer_Br3Sy0LFODuOaozPF179 button {
  width: fit-content;
  margin-bottom: 1rem;
}

.style-module_subtitle_tUrlezdT4nj_AxlHedtv {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}

.style-module_title_jyYn1WrJTSda7nnosej3 {
  font-family: Open Sans;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: center;
}

.style-module_description_wch58xOpefIKWbkUsDa8 {
  margin: 1rem 0rem 1rem 0rem;
}
.style-module_description_wch58xOpefIKWbkUsDa8 p {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/containers/AccountDeletion/AccountDeletionFeedback/style.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,UAAA;EACA,cAAA;AAAF;AAEE;EAJF;IAKI,WAAA;EACF;AACF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAGF;AADE;EACE,kBAAA;EACA,mBAAA;AAGJ;;AACA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,2BAAA;AAEF;AADE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAGJ","sourcesContent":[".container {\n  font-family: Open Sans;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n\n  > * {\n    padding-top: 1rem;\n  }\n}\n\n.container:last-child {\n  margin-bottom: 5rem;\n}\n\n.moduleContainer {\n  width: 50%;\n  min-width: 55%;\n\n  @media screen and (max-width: 800px) {\n    width: 100%;\n  }\n}\n.body {\n  width: 80%;\n}\n\n.checkbox:first-child {\n  margin-top: 3rem;\n}\n.checkboxLabel {\n  display: flex;\n  flex-direction: row;\n}\n\n.footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 2rem;\n\n  button {\n    width: fit-content;\n    margin-bottom: 1rem;\n  }\n}\n\n.subtitle {\n  font-family: Open Sans;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.title {\n  font-family: Open Sans;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: 0em;\n  text-align: center;\n}\n\n.description {\n  margin: 1rem 0rem 1rem 0rem;\n  p {\n    font-family: Open Sans;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style-module_container_Y8xSV_wN4WaEy1VPQvOq`,
	"moduleContainer": `style-module_moduleContainer_vtxcCrt2vn3GywYAzcZQ`,
	"body": `style-module_body_RHIu7czkawAfOpTIdmai`,
	"checkbox": `style-module_checkbox_pzCewce9MHCmhN7dmU0H`,
	"checkboxLabel": `style-module_checkboxLabel_jvvrZeG4hGhELiel6sPK`,
	"footer": `style-module_footer_Br3Sy0LFODuOaozPF179`,
	"subtitle": `style-module_subtitle_tUrlezdT4nj_AxlHedtv`,
	"title": `style-module_title_jyYn1WrJTSda7nnosej3`,
	"description": `style-module_description_wch58xOpefIKWbkUsDa8`
};
export default ___CSS_LOADER_EXPORT___;
